module.exports = __webpack_public_path__ + "img/chess_checkersblue.c2d2f0c0.png";